var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.1717 12.0002L8.92868 7.75723C8.53821 7.36677 8.53821 6.7337 8.92868 6.34323C9.31914 5.95277 9.95221 5.95277 10.3427 6.34323L15.2926 11.2931C15.6831 11.6836 15.6831 12.3168 15.2926 12.7073L10.3427 17.6572C9.95221 18.0477 9.31914 18.0477 8.92868 17.6572C8.53821 17.2668 8.53821 16.6337 8.92868 16.2432L13.1717 12.0002Z",
    fill: "#545A5E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronRight);
export default __webpack_public_path__ + "static/media/icon-chevron-right.ad96cfcf6f09f895106f7857e1501f00.svg";
export { ForwardRef as ReactComponent };